// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d83e4588","255":"a854af0c","449":"1a87733a","453":"35be4028","491":"f2fd3ef3","914":"f28eea17"}[chunkId] + ".chunk.js";
};